export var source = "mutation SetUpchargeForPerfumeCaseMutation($enabled: Boolean, $page: String) {\n  setUpchargeForPerfumeCase(enabled: $enabled, page: $page) {\n    ...PerfumeCaseOfMonth\n  }\n}";
import { source as fragment1 } from "../../../helpers/fragments/perfumeCaseOfMonth.graphql";
var combined = source  + "\n" + fragment1;
export default combined;